import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LEVEL_COLORS = ['tw-bg-alert-400', 'tw-bg-on-hold-300', 'tw-bg-warning-400', 'tw-bg-success-500'];
var LABEL_COLORS = ['tw-text-alert-400', 'tw-text-on-hold-500', 'tw-text-warning-500', 'tw-text-success-500'];
export var PasswordStrengthBar = function PasswordStrengthBar(_ref) {
  var score = _ref.score,
    total = _ref.total,
    visible = _ref.visible,
    label = _ref.label;
  if (!visible || total < 2) {
    return null;
  }
  var levelIndex = score > 0 ? 4 - total + score - 1 : -1;
  var activeColor = levelIndex >= 0 ? LEVEL_COLORS[levelIndex] : '';
  var labelColor = levelIndex >= 0 ? LABEL_COLORS[levelIndex] : '';
  var segments = Array.from({
    length: total
  }, function (_, i) {
    return {
      key: "seg-".concat(i),
      active: i < score
    };
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-mt-0.8",
    children: [/*#__PURE__*/_jsx("div", {
      className: "tw-flex tw-gap-0.4",
      children: segments.map(function (_ref2) {
        var key = _ref2.key,
          active = _ref2.active;
        return /*#__PURE__*/_jsx("div", {
          className: "tw-h-0.4 tw-flex-1 tw-rounded-0.4 ".concat(active && activeColor ? activeColor : 'tw-bg-neutral-light-300')
        }, key);
      })
    }), label && /*#__PURE__*/_jsx("p", {
      className: "tw-font-caption tw-mt-0.4 ".concat(labelColor),
      children: label
    })]
  });
};